import menuReducer from './reducers';

export const { initContract, showMenu, hideMenu } = menuReducer.actions;
